import { render, staticRenderFns } from "./BecomeATeacherShow.vue?vue&type=template&id=01d4eb17&"
import script from "./BecomeATeacherShow.vue?vue&type=script&lang=js&"
export * from "./BecomeATeacherShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports